import { Badge } from '@/components/UI';
import { formatLift } from './helpers';
import type { ScorecardDraftRule } from './types';

const DraftRuleRow = ({ rule }: { rule: ScorecardDraftRule }) => (
    <div className="grid grid-cols-[minmax(180px,1fr)_minmax(160px,220px)_120px_90px] items-center gap-3 border-t border-zinc-800 py-2 text-sm first:border-t-0">
        <div className="min-w-0">
            <div className="truncate text-white">{rule.label ?? rule.featureKey}</div>
            <div className="truncate text-xs text-zinc-500">{rule.featureKey}</div>
        </div>
        <div className="truncate text-zinc-300">{rule.source.bestGroupLabel ?? '-'}</div>
        <div className={rule.source.bestGroupLift != null && rule.source.bestGroupLift >= 0 ? 'text-green-400' : 'text-red-400'}>
            {formatLift(rule.source.bestGroupLift)}
        </div>
        <Badge variant={rule.writable ? 'success' : 'secondary'}>{rule.writable ? 'Writable' : 'Skipped'}</Badge>
    </div>
);

interface TopDraftRulesSectionProps {
    rules: ScorecardDraftRule[];
}

const TopDraftRulesSection = ({ rules }: TopDraftRulesSectionProps) => (
    <div className="rounded border border-zinc-800 bg-zinc-950/40 p-3">
        <div className="mb-2 font-medium text-white">Top Draft Rules</div>
        {rules.length > 0 ? (
            <div>
                {rules.map((rule) => (
                    <DraftRuleRow key={`${rule.rank}:${rule.featureId}`} rule={rule} />
                ))}
            </div>
        ) : (
            <div className="text-sm text-zinc-500">No draft rules available for the current filters.</div>
        )}
    </div>
);

export default TopDraftRulesSection;
